import { useLocalStorage } from "@mantine/hooks";

export const CREATE_BOARD_MODAL_PROMPT_STORAGE_KEY = "create-board-modal-store";

export function clearCreateBoardModalStorageOnLogout(): void {
	try {
		localStorage.removeItem(CREATE_BOARD_MODAL_PROMPT_STORAGE_KEY);
	} catch {
		// localStorage may be unavailable
	}
}

export function useCreateBoardModalStore() {
	const [savedPrompt, savePrompt, resetPrompt] = useLocalStorage({
		key: CREATE_BOARD_MODAL_PROMPT_STORAGE_KEY,
		defaultValue: "",
		getInitialValueInEffect: false,
	});

	return {
		savedPrompt,
		savePrompt,
		resetPrompt,
	};
}
